import api from '../../api'

export type UserCountReportDataRow = {
  tenantId: number
  tenantName: string
  planName: string
  assignedUserCount: number
  actualUserCount: number
}

type UserCountReportData = {
  rows: UserCountReportDataRow[]
}

export const getUserCountReportData = async () => {
  const response = await api.get<UserCountReportData>('/web/user-counts')
  return response.data.rows
}
